<mat-progress-bar *ngIf="loading" mode="indeterminate"></mat-progress-bar>
<main class="login-page">
    <mat-card class="login-card">
      <div class="logo-button">
        <img class="fraud-logo" mat-card-image src="/assets/logos/logo-fraud.png" alt="Fraude logo">
        <div class="card-actions">
            <div class="login-button-space">
              <span>         
           <div id="g_signin_div">
           </div>
              </span>
            </div>
          </div>
      </div>
      </mat-card>
  </main>
  
  